import { supabase } from '../services/supabaseClient';

export async function finalizarAtendimento(atendimentoId) {
  // 1. Finaliza o atendimento normalmente
  const { data: atendimento, error } = await supabase
    .from('atendimentos')
    .update({
      status: 'finalizado',
      finalizado_em: new Date().toISOString(),
    })
    .eq('id', atendimentoId)
    .select()
    .single();

  if (error) throw error;

  // NOVA LÓGICA: Registrar uso dos serviços para mensalistas
  if (atendimento && atendimento.mensalista_id) {
    // Buscar os serviços realizados neste atendimento
    const { data: servicosAtendimento, error: errorServ } = await supabase
      .from('atendimentos_servicos')
      .select('servico_id, quantidade')
      .eq('atendimento_id', atendimentoId);

    if (!errorServ && servicosAtendimento) {
      for (const servico of servicosAtendimento) {
        await supabase.from('mensalista_pacote_servico_uso').insert({
          mensalista_id: atendimento.mensalista_id,
          servico_id: servico.servico_id,
          quantidade: servico.quantidade,
          data_uso: new Date().toISOString(),
          atendimento_id: atendimentoId
        });
      }
    }
  }

  return atendimento;
}
